import type { PaginationParams } from "@/types";

export type PageRequest = Required<PaginationParams>;

/**
 * Collects every row of a `skip`/`limit` list endpoint, page by page, so callers
 * never get a silently truncated list.
 *
 * `pageSize` must equal the endpoint's backend `Query(le=…)` cap: a larger value
 * is rejected with 422, a smaller one only costs extra round-trips. A page shorter
 * than `pageSize` is the last one.
 */
export async function fetchAllPages<T>(
  fetchPage: (page: PageRequest) => Promise<T[]>,
  pageSize: number,
): Promise<T[]> {
  const rows: T[] = [];
  for (let skip = 0; ; skip += pageSize) {
    const page = await fetchPage({ skip, limit: pageSize });
    rows.push(...page);
    if (page.length < pageSize) return rows;
  }
}
